import type { ReactNode } from 'react';

export type V3AuthStateKind =
  | 'prepare'
  | 'root'
  | 'timeout'
  | 'error'
  | 'success'
  | 'failure';

const CHECK = 'M5 13l4 4L19 7';
const CROSS = 'M6 18L18 6M6 6l12 12';

export function V3AuthState(props: {
  readonly kind: V3AuthStateKind;
  readonly title: string;
  readonly text?: string;
  readonly chip?: string;
  readonly label: string;
  readonly loginHref?: string;
  readonly loginLabel?: string;
  readonly children?: ReactNode;
}) {
  const icon =
    props.kind === 'success' ? CHECK : props.kind === 'failure' ? CROSS : null;
  return (
    <div
      className="v3p-page"
      style={{ maxWidth: 480, minHeight: '60vh', justifyContent: 'center' }}
    >
      <section
        className="v3-card v3p-center"
        data-od-id="auth-state"
        aria-live="polite"
        aria-label={props.label}
      >
        {(props.kind === 'prepare' || props.kind === 'root') && (
          <span
            className="v3p-spin"
            role="status"
            aria-label={props.label}
          />
        )}
        {icon && (
          <span
            className={`v3p-ico ${props.kind === 'success' ? 'okc' : 'badc'}`}
          >
            <svg
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d={icon}
              />
            </svg>
          </span>
        )}
        {props.chip && (
          <span
            className={`v3-chip ${
              props.kind === 'timeout' ? 'c-warn' : 'c-bad'
            }`}
          >
            {props.chip}
          </span>
        )}
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700 }}>{props.title}</h1>
        {props.text && <p className="v3p-mu">{props.text}</p>}
        {props.kind === 'prepare' && (
          <div
            className="v3p-sk"
            style={{ height: 8, width: '100%' }}
            data-od-id="auth-progress"
          />
        )}
        {props.children}
        {props.loginHref && (
          <div className="v3p-row">
            <a
              className="v3-btn ghost"
              href={props.loginHref}
            >
              {props.loginLabel}
            </a>
          </div>
        )}
      </section>
    </div>
  );
}
